<template>
    <v-navigation-drawer id="facetDrawer" v-model="drawer" :width="drawerWidth" right fixed app  temporary disable-resize-watcher>
        <v-toolbar flat dark color="primary" dense="">
            <v-toolbar-title>Part Type Filters</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="drawer = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-container fluid grid-list-xl>
            <v-tabs slider-color="primary">
                <v-tab key="current">
                    Current Search
                </v-tab>
                <v-tab key="global">
                    Global Part Types
                </v-tab>
                <v-tab-item key="current">
                    <v-layout wrap align-center>
                        <v-flex sm12>
                            <v-btn :disabled="!buttonsEnabled" @click="all" color="primary">Show All</v-btn>
                            <v-btn :disabled="!buttonsEnabled" @click="invert" color="primary">Invert</v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex v-if="groups" xs12 sm12 md6 lg6 d-flex v-for="(group,groupIndex) in groups" :key="'group'+groupIndex">
                            <v-card class="ma-0 pa-0">
                                <v-card-title>
                                    <h3>{{translatedGroupName(group.index)}}</h3>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="ma-0 pa-1" v-for="(product,productIndex) in group.products" :key="'product'+productIndex">
                                    <v-switch
                                            @click.native="toggle(product)"
                                            class="pa-1 ma-0"
                                            color="primary"
                                            :label="`${translatedPartType(product.partType)} (${product.facetCount || 0})`"
                                            :disabled="!product.enabled"
                                            v-model="product.enabled"
                                    ></v-switch>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-tab-item>
                <v-tab-item key="global">
                    <v-layout row wrap>
                        <v-flex v-if="groups" xs12 sm12 md6 lg6 d-flex v-for="(group,groupIndex) in groups" :key="'group'+groupIndex">
                            <v-card class="ma-0 pa-0">
                                <v-card-title>
                                    <h3>{{translatedGroupName(group.index)}}</h3>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="ma-0 pa-1" v-for="(product,productIndex) in group.products" :key="'product'+productIndex">
                                    <v-switch
                                            class="pa-1 ma-0"
                                            color="primary"
                                            :label="`${translatedPartType(product.partType)}`"
                                            v-model="localGlobalFilters"
                                            :value="product.partType"
                                    ></v-switch>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-tab-item>
            </v-tabs>
        </v-container>
    </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data: () => ({
    drawer: false,
    groups: null,
    filters: null,
    buttonsEnabled: false
  }),
  created () {
    this.$events.on('APP_FILTERS_TOGGLED', () => {
      this.drawer = (!this.drawer)
    })
    this.filters = new Set()
  },
  mounted () {
    this.$events.listen('searchEvent', searchData => {
      this.$log.debug(searchData)
      if (searchData) {
        this.update(searchData)
        this.$forceUpdate()
      } else {
        // clear the count
        this.clearCount()
        this.$forceUpdate()
        // clear the facets
        // this.reset()
        // this.$forceUpdate()
        // this.$log.debug('Null Search Event')
      }
    })
    //  Get Product Groups
    this.axios.get('product-group', {})
      .then(response => {
        this.groups = response.data.data
      })
      .catch(e => {
        this.$log.error(e)
      }).finally(() => {

      })
  },
  computed: {
    ...mapGetters(
      'filters', {
        globalFilters: 'globalFilters',
        globalFiltersDefault: 'globalFiltersDefault'
      }
    ),
    localGlobalFilters: {
      get: function () {
        if (this.globalFilters.length === 0) {
          return this.globalFiltersDefault
        } else {
          return this.globalFilters
        }
      },
      set: function (value) {
        this.setFilters(value)
      }
    },
    drawerWidth () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '220px'
        case 'sm': return '400px'
        case 'md': return '500px'
        case 'lg': return '800px'
        case 'xl': return '800px'
      }
    }
  },
  methods: {
    ...mapActions(
      'filters', {
        setFilters: 'setFilters'
      }
    ),
    toggleFilters () {
      this.$events.emit('APP_FILTERS_TOGGLED', null)
    },
    translatedGroupName (index) {
      return this.$t(`message.group-${index}`)
    },
    translatedPartType (partType) {
      return this.$t(`message.parttype-${partType}`)
    },
    reset () {
      this.$log.debug(`Reset called`)
      this.buttonsEnabled = false
      this.groups.forEach(group => {
        group.products.forEach(product => {
          product.facetCount = 0
          product.status = false
          product.enabled = false
        })
      })
    },
    clearCount () {
      this.$log.debug(`Clear Count called`)
      this.buttonsEnabled = false
      this.groups.forEach(group => {
        group.products.forEach(product => {
          product.facetCount = 0
        })
      })
    },
    update (search) {
      if (!this.groups) {
        return
      }
      this.$log.debug(`Update called`)
      this.groups.forEach(group => {
        group.products.forEach(product => {
          let filteredFacet = null
          if (search.facets) {
            filteredFacet = search.facets.find(f => f.part === product.partType)
          }
          let unfilteredFacet = null
          if (search.unfiltered) {
            unfilteredFacet = search.unfiltered.facets.find(f => f.part === product.partType)
          }
          if (unfilteredFacet && !filteredFacet) {
            product.facetCount = -unfilteredFacet.count
            product.enabled = true
            product.status = true
          } else if (filteredFacet) {
            product.facetCount = filteredFacet.count
            product.enabled = true
            product.status = true
          } else {
            product.facetCount = 0
            product.enabled = false
            product.status = false
          }
        })
      })
      this.buttonsEnabled = true
    },
    toggle (filter) {
      this.$log.debug(`Toggle called, filter: ${filter.name}`)
      if (this.filters.has(filter.partType)) {
        this.filters.delete(filter.partType)
      } else {
        this.filters.add(filter.partType)
      }
      this.$log.debug(`Emitting filter event: ${Array.from(this.filters)}`)
      this.$events.$emit('filterEvent', Array.from(this.filters))
    },
    invert () {
      this.$log.debug(`Invert called`)
    },
    all () {
      this.$log.debug(`All called`)
    }
  }
}
</script>

<style scoped>

    .large .v-checkbox {
        padding: 0px;
    }

</style>
